/**
 * Placeholder company logo, served as a static asset from the portal.
 *
 * Built as an absolute URL on purpose: the value is stored on the account and read back by other
 * consumers (invoice emails, the mobile app), so a portal-relative path would render as a broken
 * image everywhere outside the portal.
 */
export const DEFAULT_LOGO = `${window.location.origin}/default-logo.svg`;

/** The account's logo, or the placeholder when it has none. */
export const accountLogo = (logo?: string | null): string => logo || DEFAULT_LOGO;
